<section *ngIf="statusService.isLoading" class="background">
  <ids-loading size="XL" class="loading-center">
    <ids-icon variant="primary" size="XL">consorcio_imobiliario_outline</ids-icon>
  </ids-loading>

  <label class="loading-center text-center">{{ title }}</label>
</section>
